import { useStore } from "../stores";

export const SearchBox = () => {
  const [searchString, setSearchString] = useStore((state) => [
    state.searchString,
    state.setSearchString,
  ]);

  return (
    <input
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      type="text"
      value={searchString}
      onChange={(e) => setSearchString(e.target.value)}
      className="p-2 border border-gray-300 rounded-md w-full focus:shadow-lg focus:outline-none"
      placeholder="Sök på din adress"
    />
  );
};
